import React from "react";
import {
  Box,
  Button,
  Container,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { Home as HomeIcon } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
import { themeStyle } from "../components/Components";

const NotFoundPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          textAlign: "center",
          p: 3,
        }}
      >
        <Typography
          variant={isMobile ? "h2" : "h1"}
          sx={{
            fontWeight: "bold",
            mb: 2,
            color: "black",
          }}
        >
          401
        </Typography>

        <Typography variant={isMobile ? "h5" : "h4"} sx={{ mb: 2 }}>
          Unauthorized
        </Typography>

        <Typography variant="body1" sx={{ mb: 4, maxWidth: 600 }}>
          Permission to view this page is denied by admin. If you think there is
          a mistake, please contact the admisnistrator.
        </Typography>

        <Button
          component={RouterLink}
          to="/"
          variant="contained"
          size="large"
          startIcon={<HomeIcon />}
          sx={{
            backgroundColor: themeStyle.primaryButtonColor,
            borderRadius: 2,
            px: 4,
            py: 1.5,
            textTransform: "none",
            fontSize: isMobile ? "1rem" : "1.1rem",
          }}
        >
          Go to Homepage
        </Button>

        <Box sx={{ height: "250px" }} />
      </Box>
    </Container>
  );
};

export default NotFoundPage;
